export default __webpack_public_path__ + "static/media/floor-6.85ee38d4.jpg";